import React from 'react';
import './Banner.css';

const Banner = () => {
    return (
        <div className="banner-section">
            <h6>Welcome <br />
                To the PlantStore</h6>
            <p>“The clearest way into the Universe is through a forest wilderness.”</p>
        </div>
    );
};

export default Banner;